import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Editor, Text, Switch, MultipleUpload } from "components/fields";
import { editInfoProduct, getProductByID } from "../../actions";
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router";
import { validationSchemaInfo, initialValuesInfo } from "../components/common";
import { toastAlert } from "@paylixecommerce/shared/components";
import { Spin2, Button } from "components";
import includes from "lodash/includes";
import {useDispatch, useSelector} from "react-redux";
import getCDNLink from "../../../../../../../constants/cdn-link";
import moment from "moment";
import { NotFoundIcon } from "./product";

import "../components/style.scss";


const EditInfoCard = ({ isAdmin }) => {

    const [initialValues, setInitial] = useState(initialValuesInfo);
	const [removedImages, setRemovedImages] = useState([]);
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

	const { id } = useParams();
	const { profile } = useSelector(({ auth }) => auth);
	const isBusiness = profile && profile.subscription && (profile.subscription.id === 1 || profile.subscription.id === 5);

	const [created, setCreated] = useState(false);
	const [product, setProduct] = useState(null);
	const [notFound, setNotFound] = useState(null);


	useEffect(() => {
		if (id) {
			getProduct();
		}
	}, []);

	const getProduct = () => {
		dispatch(getProductByID(id))
			.then(res => {
				if(res.status === 404) {
					setProduct(null)
					setNotFound(true)
				} else {
					setProduct(res.data.product);
				}
			});
	}

	const onSubmit = (values) => {

		setCreated(true);

		const admin = includes(location.pathname, 'admin');

		let data = {...values};

		if(removedImages.length) {
			data.remove_images_uniqids = removedImages;
		}

		data.image = data.image.map(v => {
			if(v.size) {
				return v
			} else {
				return null
			}
		}).filter((i) => i);

		if(data.image.length) {
			data.image = data.image[0];
		}

		data.default_image = 0;

        data.unlisted = Boolean(values.unlisted);
		data.private = Boolean(values.private);

		delete data.image_attachments;
		delete data.image_attachment;
		delete data.image_attachment_info;

		return dispatch(editInfoProduct(data))
			.then(res => {
				toastAlert('success', res.message);
				getProduct();
				if (admin) {
					history.back()
				}
			})
			.catch(err => {
				toastAlert('error', err ? err.error : "");
			})
			.finally(() => {
				setCreated(false);
			})
	}


	useEffect(() => {
        if(product) {

			let image = () => {

				if(product.image_attachments && product.image_attachments.length) {
					return product.image_attachments.map(i => ({
						preview: i.cloudflare_image_id ? getCDNLink({ id: i.cloudflare_image_id, type: "shopItem" }) : null,
						size: i.size ? i.size : null,
						date: i.created_at ? moment(i.created_at * 1000).format('DD, MMM YYYY HH:mm') : null,
						name: i.original_name ? i.original_name : '',
						uniqid: i.uniqid
					}))
				} else {
					return [];
				}
			}

			setInitial({
				...product,
				image: image(),
			});
		}
	}, [product]);

	let form = useFormik({
		validationSchema: validationSchemaInfo,
		enableReinitialize: true,
		initialValues: initialValues,
		onSubmit
	});

	if(notFound) {
		return <>
			<div className="edit-modal-body d-flex align-items-center justify-content-center flex-column">

				<NotFoundIcon />
				<div style={{ fontSize: 24, fontWeight: 600, color: "var(--black9)" }} className="mt-3 mb-2">Product Not Found</div>
				<div style={{ fontSize: 14, color: "var(--black9)" }}>The product with ID <span style={{ fontWeight: 500 }}>{id}</span> could not be found.</div>

			</div>

			<div className="edit-modal-footer">
				<Button type="button" size="large" variant="secondary" className="w-100" onClick={() => history.push(isAdmin ? isAdmin : '/products')}>
					Close
				</Button>
			</div>
		</>
	}

	return (
		<>

			<div className="edit-modal-header">
				<div className="edit-modal-header-title">Edit Info Card: {form.values.title}</div>
				<div className="edit-modal-header-ref" />
			</div>

			<div className="edit-modal-body">

				<form onSubmit={form.handleSubmit} className="product-form-main-back mb-0">
					<div>
						<Text label="Title" placeholder="Title" name="title" {...form} />
					</div>
					<div>
						<Editor label="Description" name="description" {...form} />
					</div>
					<div>
						<MultipleUpload isBusiness={isBusiness} remove={(id) => setRemovedImages([...removedImages, id])} name="image" {...form} label={<>Images&nbsp;<small>(optional)</small></>} />
					</div>
					<div className="mt-3 d-flex flex-wrap">
						<Switch name="unlisted" {...form} label="Unlisted" left note="The product wont be displayed on your Shop, but can still be accessed via direct URL." withBorder />
						<Switch name="private" {...form} label="Private" left note="This product will be removed from your shop and customers will not be able to use the direct link either." />
					</div>
				</form>

			</div>

			<div className="edit-modal-footer">
				<Button type="button" size="large" disabled={created} variant="secondary" onClick={() => history.push(isAdmin ? isAdmin : '/products')}>
					Cancel
				</Button>
				<Button type="submit" size="large" disabled={created} onClick={form.handleSubmit}>
					{created ? <Spin2 /> : `Update Info Product`}
				</Button>
			</div>


		</>
	)
}

export default EditInfoCard;
